import { useTranslation } from "next-i18next";
import { convertToDollar } from "@Utils/currency";
import Link from "@wff/components/Link";
import Icon from "@wff/components/ui/icon";
import { KEYS_CART } from "../translation-keys";
import classes from "./CartDrawerHeader.module.scss";

export const ITEM_COUNT_ID = "item-count";
export const DRAWER_CLOSE_ID = "drawer-close";

interface CartDrawerHeaderProps {
  totalItemCount: number | string;
  subtotal?: string | number;
  onClose: () => {
    payload: string | undefined;
    type: string;
  };
}

function CartDrawerHeader(props: CartDrawerHeaderProps) {
  const { totalItemCount, subtotal, onClose } = props;
  const { t } = useTranslation("common");
  const displayItemCount = !!(totalItemCount && totalItemCount > 0);

  return (
    <nav className={classes["cart-flyout__header"]}>
      <div className={classes["cart-flyout__back"]}>
        <button
          data-testid={DRAWER_CLOSE_ID}
          className={classes["cart-flyout__back-button"]}
          onClick={onClose}
        >
          <Icon iconName="close" />
        </button>
      </div>
      <div className={classes["cart-flyout__title"]}>
        <Link href="/cart">
          <a className={classes["cart-flyout__basket"]} onClick={onClose}>
            <i className={classes["cart-flyout__basket-icon"]}>
              <Icon iconName="basket" />
            </i>
            {displayItemCount && (
              <i
                data-count={totalItemCount}
                className={classes["cart-flyout__basket-flame"]}
                data-testid="item-count"
              >
                <Icon iconName="flame" />
              </i>
            )}
          </a>
        </Link>
        <div className={classes["cart-flyout__subtotal"]}>
          <span className={classes["cart-flyout__subtotal-label"]}>
            {t(KEYS_CART.general.subtotal)}
          </span>
          <span className={classes["cart-flyout__subtotal-value"]}>
            ${convertToDollar(Number(subtotal))}
          </span>
        </div>
      </div>
    </nav>
  );
}

export default CartDrawerHeader;
